import React, { Component } from 'react';

// Components
import Modal from '@atlaskit/modal-dialog/dist/esm/components/Modal';
import { Icon } from '@blueprintjs/core';
import AddPurchaseOrderDialog from '../../components/dialogs/AddPurchaseOrderDialog';
import VirtualizedTable from '../../components/common/virtualized-table';

import { List } from 'immutable';
import { Link } from 'react-router-dom';

class ProjectPurchaseOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null,
            purchaseOrders: this.props.project.get('purchase_orders')
        }
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        });
    };

    deletePurchaseOrder = (orderId) => {
        const purchaseOrders = this.props.project.get('purchase_orders').toJS();
        const purchaseOrdersToUpdate = purchaseOrders.filter(order => order._id !== orderId);
        this.props.updateProject(this.props.project.get('_id'), {
            purchase_orders: purchaseOrdersToUpdate
        });
    };

    render() {

        // Modal area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'purchaseOrderToProject':
                default:
                    modal = {
                        width: 'large',
                        title: 'Añadir pedido de compra al proyecto',
                        body: (
                            <AddPurchaseOrderDialog
                                onRef={ref => (this.child = ref)}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                project={this.props.project}
                                updateProject={this.props.updateProject}
                            />
                        ),
                        footer: (
                            <div className='modal-footer'>
                                <button
                                    key={'cancel'}
                                    type='button'
                                    className='btn btn-cancel'
                                    label='Cancelar'
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    Cancelar
                                </button>
                                <button
                                    key={'accept'}
                                    type='button'
                                    className='btn btn-primary'
                                    disabled={!this.state.canSubmit}
                                    onClick={() => {
                                        this.child.onAddButtonClick();
                                    }}
                                >
                                    Añadir
                                </button>
                            </div>
                        )
                    };
                    break;
            }
        }

        const purchaseOrdersTableColumns = {
            order_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: 'Fecha documento',
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY',
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'requested':
                            data.badgeColor = 'warning';
                            data.value = 'Solicitado';
                            break;
                        case 'partial':
                            data.badgeColor = 'warning-light';
                            data.value = 'Parcial';
                            break;
                        case 'received':
                            data.badgeColor = 'primary';
                            data.value = 'Recibido';
                            break;
                        case 'invoiced':
                            data.badgeColor = 'success';
                            data.value = 'Facturado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (orderId) => {
                    return (
                        <Icon
                            className='cursor-pointer'
                            icon='trash'
                            iconSize={18}
                            onClick={() => this.deletePurchaseOrder(orderId)}
                        />
                    )
                }
            }
        };

        const purchaseOrdersTableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 480,
            rowHeight: 40,
            strippedRows: false,
        };

        const purchaseOrdersTableData = this.props.project.get('purchase_orders') || List([]);

        return (
            <div className='panel-body'>
                <div className='row stats-zone' style={{ margin: '10px 0' }}>
                    <div className='col-auto'>
                        <span className='label label-primary'>{this.props.project.get('purchase_orders').size}</span>
                        <span>Pedidos de compra asociados al proyecto</span>
                    </div>
                    <div className='col-auto ml-auto'>
                        <button
                            className='btn btn-primary'
                            onClick={() => this.openModal('purchaseOrderToProject')}
                        >
                            <Icon icon='arrow-left' /> Añadir pedido
                        </button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <VirtualizedTable
                            tableSettings={purchaseOrdersTableSettings}
                            tableColumns={purchaseOrdersTableColumns}
                            tableData={purchaseOrdersTableData}
                        />
                    </div>
                </div>
                {this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    };
}

export default ProjectPurchaseOrders;


// WEBPACK FOOTER //
// ./src/containers/projects/ProjectPurchaseOrders.js